import { defaultHttpClient } from '../../httpClient';
import type { GetMarketRankingTypesResponse } from './types';

export const getMarketRankingTypes = () => {
  return defaultHttpClient
    .request<GetMarketRankingTypesResponse>({
      method: 'GET',
      url: '/api/v2/markets/rankings/available_types/',
    })
    .then(result => result.data);
};
